function animations() {
  function initObservers() {
    if (document.documentElement.clientWidth > 767) {
      const options = {
        // родитель целевого элемента - область просмотра
        root: null,
        // без отступов
        rootMargin: '0px',
        // процент пересечения - половина изображения
        threshold: 0.5
      }
    
      // создаем наблюдатель
      const observer = new IntersectionObserver((entries, observer) => {
        // для каждой записи-целевого элемента
        entries.forEach(entry => {
          // если элемент является наблюдаемым
          if (entry.isIntersecting) {
            let image = entry.target;
            image.classList.add('is-active')
            // прекращаем наблюдение
            observer.unobserve(image)
          }
        })
      }, options)
    
      // с помощью цикла следим за всеми img на странице
      const arr = document.querySelectorAll('.process__footer-item--with-animation')
      arr.forEach(i => {
        observer.observe(i)
      })
    } else {
      const options = {
        // родитель целевого элемента - область просмотра
        root: null,
        // без отступов
        rootMargin: '0px',
        // процент пересечения - половина изображения
        threshold: 0.5
      }
    
      // создаем наблюдатель
      const observer = new IntersectionObserver((entries, observer) => {
        // для каждой записи-целевого элемента
        entries.forEach(entry => {
          // если элемент является наблюдаемым
          if (entry.isIntersecting) {
            let image = entry.target;
            image.classList.add('is-active')
            // прекращаем наблюдение
            observer.unobserve(image)
          }
        })
      }, options)
    
      // с помощью цикла следим за всеми img на странице
      const arr = document.querySelectorAll('.teams__controls')
      arr.forEach(i => {
        observer.observe(i)
      })
    }
  }

  initObservers();

  window.addEventListener('resize', initObservers)
}

export { animations }